/**
 * HUD icon registry.
 *
 * Most gameplay icons are generated bitmap assets rendered as inline
 * <img> snippets. A few control/metaphor icons remain Unicode where a
 * crisp symbol is clearer than art (checkmarks, locks, rotate arrows).
 */

function hudIcon(name: string, alt: string): string {
  return `<img class="ui-icon-img" src="/icons/hud/${name}.png" alt="${alt}" draggable="false">`;
}

export const ICON = {
  // Resources
  coin:     hudIcon('coin', 'Coins'),
  wheat:    hudIcon('wheat', 'Wheat'),
  corn:     hudIcon('corn', 'Corn'),
  carrot:   hudIcon('carrot', 'Carrot'),
  flour:    hudIcon('flour', 'Flour'),
  energy:   hudIcon('energy', 'Energy'),
  wood:     hudIcon('wood', 'Wood'),
  stone:    hudIcon('stone', 'Stone'),
  mushroom: hudIcon('mushroom', 'Mushroom'),
  berry:    hudIcon('berry', 'Berries'),
  acorn:    hudIcon('acorn', 'Acorn'),

  hands:    '✋',
  hoe:      hudIcon('hoe', 'Hoe'),
  field:    hudIcon('hoe', 'Hoe'),
  scythe:   hudIcon('sickle', 'Sickle'),
  bag:      hudIcon('seed-bag', 'Seed bag'),
  seed:     hudIcon('seed-bag', 'Seeds'),
  plant:    hudIcon('seed-bag', 'Plant'),
  axe:      hudIcon('axe', 'Axe'),
  pickaxe:  hudIcon('pickaxe', 'Pickaxe'),
  water:    hudIcon('water', 'Watering can'),

  // Side-panel buttons
  storage:  hudIcon('storage', 'Storage'),
  truck:    hudIcon('truck', 'Truck'),
  plot:     hudIcon('plot', 'Plot area'),
  progress: hudIcon('skills', 'Skills'),
  save:     hudIcon('save', 'Save'),
  goal:     hudIcon('goal', 'Goal'),
  sprout:   hudIcon('sprout', 'Sprout'),
  sun:      hudIcon('sun', 'Sun'),
  moon:     hudIcon('moon', 'Moon'),
  dawn:     hudIcon('dawn', 'Dawn'),
  dusk:     hudIcon('dusk', 'Dusk'),
  spring:   hudIcon('spring', 'Spring'),
  summer:   hudIcon('summer', 'Summer'),
  fall:     hudIcon('fall', 'Fall'),
  winter:   hudIcon('winter', 'Winter'),
  sell:     hudIcon('coin', 'Sell'),
  build:    hudIcon('build', 'Build'),

  // Buildings / island cards
  farm:     hudIcon('farm', 'Farm'),
  city:     hudIcon('town', 'Town market'),
  town:     hudIcon('town', 'Town market'),
  islands:  '🏝',
  granary:  hudIcon('granary', 'Granary'),
  mill:     hudIcon('mill', 'Windmill'),

  // Character
  farmer:   hudIcon('sprout', 'Farmer'),

  // Misc small
  lock:     '🔒',
  check:    '✓',
};
